import { useEffect, useState } from 'react'

/**
 * @function useVisibleHeight - хук для получения высоты видимой части окна
 * @returns {visibleHeight} - состояние visibleHeight обновляется только при реальных изменениях размера,
 *    из-за виртуальной клавиатуры или прокрутки, что является оптимальным поведением
 */
export const useVisibleHeight = () => {
  const [visibleHeight, setVisibleHeight] = useState<number>(0)

  useEffect(() => {
    if (!window.visualViewport) return

    const updateHeight = () => {
      if (window.visualViewport) {
        setVisibleHeight(window.visualViewport.height)
      }
    }

    // подписываемся на события resize и scroll только один раз
    window.visualViewport.addEventListener('resize', updateHeight)
    window.visualViewport.addEventListener('scroll', updateHeight)

    // устанавливаем начальное значение
    updateHeight()

    // отписываемся при размонтировании компонента
    return () => {
      window.visualViewport.removeEventListener('resize', updateHeight)
      window.visualViewport.removeEventListener('scroll', updateHeight)
    }
  }, [])

  return visibleHeight
}
